import logo from '@assets/svg/logo.svg';
import { Link } from '@mui/material';
export const RexelLogo = () => {
  return (
    <Link href="/login">
      <img src={logo} alt="Rexel Logo" width={127} />
    </Link>
  );
};
